import React from 'react';
import { useTheme } from 'styled-components';

export default function VideoRecordingOutlineIcon({
  size = 16,
  color = '#767476',
  darkfy = false,
}) {
  const theme = useTheme();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.35301 13.6233H4.13967C2.03301 13.6233 1.33301 12.2233 1.33301 10.8167V5.20333C1.33301 3.09667 2.03301 2.39667 4.13967 2.39667H8.35301C10.4597 2.39667 11.1597 3.09667 11.1597 5.20333V10.8167C11.1597 12.9233 10.453 13.6233 8.35301 13.6233Z"
        stroke={theme?.dark || darkfy ? theme.primaryText || '#FFFFFFCC' : color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0135 11.41L11.1602 10.11V5.90332L13.0135 4.60332C13.9202 3.96999 14.6668 4.35666 14.6668 5.46999V10.55C14.6668 11.6633 13.9202 12.05 13.0135 11.41Z"
        stroke={theme?.dark || darkfy ? theme.primaryText || '#FFFFFFCC' : color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66699 7.34332C8.21928 7.34332 8.66699 6.89561 8.66699 6.34332C8.66699 5.79104 8.21928 5.34332 7.66699 5.34332C7.11471 5.34332 6.66699 5.79104 6.66699 6.34332C6.66699 6.89561 7.11471 7.34332 7.66699 7.34332Z"
        stroke={theme?.dark || darkfy ? theme.primaryText || '#FFFFFFCC' : color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
